var shared = require('../internals/shared');
var uid = require('../internals/uid');

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/shared-key.js
// module id = 111
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35